import { createContext } from "react";

export const OrderConfigContext = createContext();
